import { render, staticRenderFns } from "./sdetail.vue?vue&type=template&id=5166236c&"
import script from "./sdetail.vue?vue&type=script&lang=js&"
export * from "./sdetail.vue?vue&type=script&lang=js&"
import style0 from "./sdetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports